import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import {
  getTodayDate,

} from "../../../../common/Validations";

//API
import ItemServiceV2 from "../../../../services/customer_v2_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { getOrderSchedulingList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { getMaterialListv2 } from "../../../../redux/feature/customer_app/customerSlice";

const OrderConfirmationModal = React.forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const [isCardVisible1, setCardVisible1] = useState(true);

  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };

  const [lineItmes, setLineItems] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [viewStatus, setViewStatus] = useState(false);
  const [propsData, setPropsData] = useState();
   // eslint-disable-next-line
  const [formInputs, setFormInputs] = useState();
   // eslint-disable-next-line 
  const [godownData, setGodownData] = useState([]);
   // eslint-disable-next-line 
  const [truckData, setTruckData] = useState([]);

  const [disabled, setDisabled] = useState(false);
  const [materialCodes, setMaterialCodes] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(false);

  let materialData = useSelector((state) => state?.customer?.material?.data);
  // Dispatch getMaterialListv2 when materialCodes are available
  useEffect(() => {
    if (materialCodes.length > 0) {
      const obj = {
        "queryName": "Get_ALL_Materials",
        "page": 1,
        "per_page": 10,
        "searchTerm": "",
        "rowFilter": {
          "$and": [
            {
              "materialType": "POC"
            }
            // {
            //   "materialCode": { "$in": materialCodes }
            // }
          ]
        }
      };
      dispatch(getMaterialListv2(obj));
    }
    // eslint-disable-next-line
  }, [materialCodes]);

  // Map basePrimaryQuantity from materialData to lineItmes
  useEffect(() => {
    if (materialData && materialData.length > 0 && lineItmes.length > 0) {
      const updatedLineItems = lineItmes.map((item) => {
        const matchedMaterial = materialData.find(
          (m) => m.materialCode === item.materialCode
        );
        if (matchedMaterial) {
          return {
            ...item,
            baseprimaryquantity: matchedMaterial.baseprimaryquantity || "--",
          };
        }
        return item;
      });
      setLineItems(updatedLineItems);
    }
    // eslint-disable-next-line
  }, [materialData]);

  useEffect(() => {
    setPropsData(props.loadingadvicedata);
  }, [props?.loadingadvicedata]);

  // Check if all items are already confirmed - disable save button
  useEffect(() => {
    if (lineItmes.length > 0 && propsData?.updateSoStatus) {
      const allConfirmed = lineItmes.every((item) => {
        const status = propsData.updateSoStatus.find(
          (s) => s.materialCode === item.materialCode
        );
        return status?.orderConfirmed === true;
      });
      setIsSaveDisabled(allConfirmed);
    }
  }, [lineItmes, propsData?.updateSoStatus]);

  // const lineItemCol = [
  //   {
  //     name: "Product",
  //     cell: (row) => (
  //       <div>
  //         <p className="m-0 p-0 pt-1 fw-bold ">{row?.materialDescription} </p>
  //         <p className="m-0 p-0 ">{row?.materialCode} </p>
  //       </div>
  //     ),
  //     width: "250px",
  //   },
  //   {
  //     name: "Qty",
  //     cell: (row) => (
  //       <div>
  //         <p className="m-0 p-0 pt-1 fw-bold ">{row?.orderQuantityLoad} </p>
  //         <p className="m-0 p-0 ">{row?.uOM} </p>
  //       </div>
  //     ),
  //     width: "100px",
  //   },
  //   {
  //     name: "Load Qty",
  //     cell: (row) => (
  //       <>
  //         <InputField
  //           // type="number"
  //           className="inputBox mt-1"
  //           // label="Date"
  //           name="orderQtyLoadConfirm"
  //           id="orderQtyLoadConfirm"
  //           value={
  //             row?.orderQtyLoadConfirm !== undefined &&
  //             row?.orderQtyLoadConfirm !== null
  //               ? row.orderQtyLoadConfirm
  //               : ""
  //           }
  //           onChange={(event) => handleInputChange(row?.local_id, event)}
  //           disabled={row?.balanceQty === 0 ? true : false}
  //         />
  //       </>
  //     ),
  //     width: "130px",
  //   },
  //   {
  //     name: "Balance Load Qty",
  //     cell: (row) => (
  //       <>
  //         <InputField
  //           className="inputBox mt-1"
  //           // label="Date"
  //           name="balanceQty"
  //           id="balanceQty"
  //           value={row?.balanceQty}
  //           // value={
  //           //   row?.balanceQty ??
  //           //   row?.orderQuantityLoad - (row?.orderQtyLoadConfirm || 0)
  //           // }
  //           // onChange={(event) => handleInputChange(row?.local_id, event)}
  //           disabled={true}
  //         />
  //       </>
  //     ),
  //     width: "140px",
  //   },
  //   {
  //     name: "Date",
  //     cell: (row) => (
  //       <>
  //         <InputField
  //           className="inputBox mt-1"
  //           // label="Date"
  //           name="loadingDate"
  //           id="loadingDate"
  //           type="date"
  //           value={row?.loadingDate}
  //           onChange={(event) => handleInputChange(row.local_id, event)}
  //           disabled={viewStatus}
  //         />
  //       </>
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Time",
  //     cell: (row) => (
  //       <>
  //         <InputField
  //           className="inputBox"
  //           label=""
  //           name="loadingTime"
  //           id="loadingTime"
  //           type="time"
  //           value={row?.loadingTime}
  //           onChange={(event) => handleInputChange(row.local_id, event)}
  //           disabled={viewStatus}
  //         />
  //       </>
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Ex-work",
  //     cell: (row) => (
  //       <div>
  //         <p className="m-0 p-0 pt-1 fw-bold ">{row?.exWork || "--"} </p>
  //       </div>
  //     ),
  //     width: "100px",
  //   },
  //   {
  //     name: "Godown",
  //     cell: (row) => (
  //       <>
  //         {viewStatus ? (
  //           <InputField
  //             className="inputBox"
  //             // label="Godown"
  //             name="godownAddress"
  //             id="godownAddress"
  //             value={row.godownAddress}
  //             // onChange={(event) => handleInputChange(row?.local_id, event)}
  //             disabled={viewStatus}
  //           />
  //         ) : (
  //           <TableDropdownMenu
  //             index={row?.local_id}
  //             label={"Godown"}
  //             data={godownData}
  //             id={"godownAddress"}
  //             name={"godownAddress"}
  //             code={"godownAddressCode"}
  //             description={"godownAddressDescription"}
  //             onChange={handleDropdownChange}
  //             // required={true}
  //           />
  //         )}
  //       </>
  //     ),
  //     sortable: true,
  //     width: "280px",
  //   },
  //   // {
  //   //   name: "Truck No",
  //   //   cell: (row) => {
  //   //     if (row?.exWork && row?.exWork === "Ex-Work") {
  //   //       return null; // 👈 completely hide column cell
  //   //     }

  //   //     return (
  //   //       <>
  //   //         {viewStatus ? (
  //   //           <InputField
  //   //             className="inputBox"
  //   //             name="loadingTruckNo"
  //   //             id="loadingTruckNo"
  //   //             value={row.loadingTruckNo}
  //   //             disabled={viewStatus}
  //   //           />
  //   //         ) : (
  //   //           <TableDropdownMenu
  //   //             index={row?.local_id}
  //   //             label={"Truck No"}
  //   //             data={truckData}
  //   //             id={"loadingTruckNo"}
  //   //             name={"loadingTruckNo"}
  //   //             code={"loadingTruckNoCode"}
  //   //             description={"loadingTruckNoDescription"}
  //   //             onChange={handleDropdownChange}
  //   //           />
  //   //         )}
  //   //       </>
  //   //     );
  //   //   },
  //   //   sortable: true,
  //   //   width: "200px",
  //   // },

  //   {
  //     name: "Truck No",
  //     cell: (row) => {
  //       if (row?.exWork && row?.exWork === "Ex-Work") {
  //         return null; // 👈 completely hide column cell
  //       }

  //       return (
  //         <>
  //           {viewStatus ? (
  //             <InputField
  //               className="inputBox"
  //               name="loadingTruckNo"
  //               id="loadingTruckNo"
  //               value={row.loadingTruckNo}
  //               disabled={viewStatus}
  //             />
  //           ) : (
  //             <TableDropdownMenu
  //               index={row?.local_id}
  //               label={"Truck No"}
  //               data={truckData}
  //               id={"loadingTruckNo"}
  //               name={"loadingTruckNo"}
  //               code={"loadingTruckNoCode"}
  //               description={"loadingTruckNoDescription"}
  //               onChange={handleDropdownChange}
  //               // required={true}
  //             />
  //           )}
  //         </>
  //       );
  //     },

  //     sortable: true,
  //     width: "200px",
  //   },
  //   {
  //     name: "Other TruckNo",
  //     cell: (row) => (
  //       <>
  //         {row?.loadingTruckNoCode === "000" && (
  //           <InputField
  //             className="inputBox"
  //             name="loadingOtherTruckNo"
  //             id="loadingOtherTruckNo"
  //             value={row?.loadingOtherTruckNo}
  //             onChange={(event) => handleInputChange(row.local_id, event)}
  //             disabled={false}
  //           />
  //         )}
  //       </>
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Driver Name",
  //     cell: (row) => (
  //       <>
  //         <InputField
  //           className="inputBox"
  //           // label="Driver Name"
  //           name="transporterDriverName"
  //           id="transporterDriverName"
  //           value={row?.transporterDriverName}
  //           onChange={(event) => handleInputChange(row.local_id, event)}
  //           disabled={viewStatus}
  //         />
  //       </>
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Driver Contact",
  //     cell: (row) => (
  //       <>
  //         <InputField
  //           className="inputBox"
  //           // label="Driver Contact"
  //           name="transporterDriverContact"
  //           id="transporterDriverContact"
  //           onChange={(event) => handleInputChange(row.local_id, event)}
  //           value={row?.transporterDriverContact}
  //           disabled={viewStatus}
  //         />
  //       </>
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Shipped Party",
  //     cell: (row) => (
  //       <>
  //         <TextAreaField
  //           className="inputBox"
  //           // label="Driver Contact"
  //           name="shippedParty"
  //           id="shippedParty"
  //           onChange={(event) => handleInputChange(row.local_id, event)}
  //           value={row?.shippedParty}
  //           disabled={viewStatus}
  //         />
  //       </>
  //     ),
  //     width: "160px",
  //   },

  //   // {
  //   //   name: "Unit Price",
  //   //   cell: (row) => <span>{row.unitPrice} </span>,
  //   //   width: "130px",
  //   // },
  //   // {
  //   //   name: "Rate",
  //   //   cell: (row) => <span>{row.rate} </span>,
  //   //   width: "130px",
  //   // },
  //   // {
  //   //   name: "Customer Name",
  //   //   cell: (row) => (
  //   //     <>
  //   //       <p>{row?.customerName}</p>
  //   //     </>
  //   //   ),
  //   //   width: "130px",
  //   // },
  //   {
  //     name: "Shipping Addr",
  //     cell: (row) => (
  //       <>
  //         <p>{row?.shippingAddress}</p>
  //       </>
  //     ),
  //     width: "180px",
  //   },
  //   {
  //     name: "Shipping Postal Code",
  //     cell: (row) => (
  //       <>
  //         <p>{row?.shippingPostalCode}</p>
  //       </>
  //     ),
  //     width: "160px",
  //   },
  // ];
const lineItemCol =[ 
    {
      name: "Material",
      id: "materialDescription",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.productName || "--",
      cell: (row) => (
        // <div className="d-flex justify-content-center w-50 align-items-center cursor-pointer">

        <div
          className="flex justify-center items-center cursor-pointer"
          // onClick={() => showAddProduct("DETAILS", row.documentNumber, row)}
        >
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>

            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Order Status",
      selector: (row) => getOrderStatus(row.materialCode),
      cell: (row) => (
        <div>
          <span
            className={`badge ${
              getOrderStatus(row.materialCode) === "Order Confirmed"
                ? "bg-success"
                : "bg-danger"
            }`}
          >
            {getOrderStatus(row.materialCode)}
          </span>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
     {
      name: "Orderd Qty",
      selector: (row) => row?.orderQuantityLoad || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Base Pri Qty",
      selector: (row) => row?.baseprimaryquantity || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "UOM",
      selector: (row) => row?.uOM || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "lglWhs",
      selector: (row) => row?.lglWhs || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Qlt",
      selector: (row) => row?.quality || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Lot",
      selector: (row) => row?.lot || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Cnr IT",
      selector: (row) => row?.cnrIt || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Cnr",
      selector: (row) => row?.cnr || "--",
      sortable: true,
      width: "130px",
    },
    {
      name: "Cnr Element",
      selector: (row) => row?.containerElement || "--",
      sortable: true,
      width: "140px",
    },
    {
      name: "Cnr Element",
      selector: (row) => row?.containerElement || "--",
      sortable: true,
      width: "140px",
    },
   
    
    {
  name: "Colour",
  selector: (row) => row.perBagBox || "--",
  cell: (row) => (
    <div>
      {row?.colour && (
<>
<div
          style={{
            width: "60px",
            height: "20px",
            backgroundColor: row.colour,
            border: "1px solid #ccc",
            borderRadius: "3px",
            marginTop: "5px"
          }}
        >   </div>
  <p className="m-0 p-0">{row?.colour}</p>
  </>     
      )}
    </div>
  ),
  sortable: true,
  width: "130px",
},
    
    {
      name: "CGST%",
      selector: (row) => row.cgst || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "SGST%",
      selector: (row) => row.sgst || "--",
      sortable: true,
      width: "100px",
    },
  ]
  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };

    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  //handle cancel modal
  const handleCancel = () => {
    props.onHide();
  };

  // Handle row selection
  const handleRowSelect = (state) => {
    setSelectedRows(state.selectedRows);
    // Check if any selected item has baseprimaryquantity < orderQuantityLoad
    const hasInsufficientStock = state.selectedRows.some(
      (row) => (row.baseprimaryquantity || 0) < (row.orderQuantityLoad || 0)
    );

    // Also check if all items were already confirmed
    const allConfirmed = lineItmes.every((item) => {
      const status = propsData?.updateSoStatus?.find(
        (s) => s.materialCode === item.materialCode
      );
      return status?.orderConfirmed === true;
    });

    setIsSaveDisabled(hasInsufficientStock || allConfirmed);
  };

  //handle save
  const handleSave = async () => {
    // Check if all items are already confirmed
    const allConfirmed = lineItmes.every((item) => {
      const status = propsData?.updateSoStatus?.find(
        (s) => s.materialCode === item.materialCode
      );
      return status?.orderConfirmed === true;
    });

    if (allConfirmed) {
      toast.error("All items are already confirmed!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    // Check if at least one item is selected
    if (selectedRows.length === 0) {
      toast.error("At least one item should be selected!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    // Check if any selected item has baseprimaryquantity < orderQuantityLoad
    const hasInsufficientStock = selectedRows.some(
      (row) => (row.baseprimaryquantity || 0) < (row.orderQuantityLoad || 0)
    );

    if (hasInsufficientStock) {
      toast.error("Cannot save: Selected item(s) have insufficient base primary quantity!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }

    setDisabled(true);

    try {
      // Call updateMaterial for each selected item
      for (const row of selectedRows) {
        const updatedBasePrimaryQty = (row.baseprimaryquantity || 0) - (row.orderQuantityLoad || 0);
        const obj = {
          materialCode: row.materialCode,
          baseprimaryquantity: updatedBasePrimaryQty
        };

        await ItemService.updateMaterial(obj);
      }

      // After all updateMaterial calls, call updateSO
      // Map all lineItems - selected ones get orderConfirmed: true, unselected keep existing status
      const selectedMaterialCodes = selectedRows.map((r) => r.materialCode);
      const updateSoStatusArray = lineItmes.map((row) => {
        const existingStatus = propsData?.updateSoStatus?.find(
          (s) => s.materialCode === row.materialCode
        );
        return {
          materialCode: row.materialCode,
          orderConfirmed: selectedMaterialCodes.includes(row.materialCode)
            ? true
            : existingStatus?.orderConfirmed ?? false
        };
      });

      const soObj = {
        orderSchedulingNr: propsData?.orderSchedulingNr || propsData?.documentNumber,
        salesDocumentNr: "",
        updateSoStatus: updateSoStatusArray
      };

      await ItemService.updateSO(soObj).then((item) => {
        if (item?.status === 200) {
          // Update local propsData to reflect the new orderConfirmed status
          const updatedUpdateSoStatus = propsData?.updateSoStatus
            ? propsData.updateSoStatus.map((s) => ({
                ...s,
                orderConfirmed: selectedMaterialCodes.includes(s.materialCode)
              }))
            : updateSoStatusArray;

          setPropsData({
            ...propsData,
            updateSoStatus: updatedUpdateSoStatus
          });

          // Also update selectedRows to reflect the confirmed status
          setSelectedRows([]);

          handleSearchFuncApi();
          toast.success(item?.message || "Order Confirmed Successfully", {
            duration: 2000,
            position: "top-right",
          });
          props.onHide();
        } else {
          console.log(">> Error: Updating SO");
        }
      });
    } catch (error) {
      console.log(">> Error: ", error);
      toast.error("Error occurred while saving!", {
        duration: 4000,
        position: "top-right",
      });
    }

    setDisabled(false);
  };

  // Handle MTO button click
  const handleMTO = () => {
    if (selectedRows.length === 0) {
      toast.error("At least one item should be selected!", {
        duration: 4000,
        position: "top-right",
      });
      return;
    }
    // Add MTO logic here
    console.log("MTO clicked for:", selectedRows);
  };

  useEffect(() => {
    let needsUpdate = false;
    const updated = lineItmes?.map((row) => {
      if (row.exWork === "Ex-Work" && row.loadingTruckNoCode !== "000") {
        needsUpdate = true;
        return {
          ...row,
          // loadingTruckNo: "000 - OTHERS",
          loadingTruckNoCode: "000",
          loadingTruckNoDescription: "OTHERS",
          loadingOtherTruckNo: row?.loadingTruckNo,
        };
      }
      return row;
    });

    if (needsUpdate) {
      setLineItems(updated); // ✅ only updates when necessary
    }
  }, [lineItmes]);

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getOrderScheduleBookingListV1",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getOrderSchedulingList(obj));
  };

  //call api for paritcular order
  const getMasterData = async () => {
    const docNumber = propsData?.orderSchedulingNr || propsData?.documentNumber;
    if (!docNumber) return;
    let obj = { documentNumber: docNumber };
    setLineItems([]);
    await ItemServiceV2.getOrderBoogkingDetail(obj).then((item) => {
      if (item?.status === 200) {
        let itemData = item?.data[0]?.items;
        // Extract material codes from itemData
        const codes = itemData?.map((i) => i.materialCode).filter(Boolean) || [];
        setMaterialCodes(codes);

        // Update existing records
        let updateItemData = itemData?.map((item, index) => ({
          ...item,
          orderQtyLoadConfirm: 0,
          loadingDate: getTodayDate(""),
          loadingTime: getCurrentTime(),
          shippedParty: item?.customerName || propsData?.customerName,
        }));

        setLineItems(updateItemData || []);
        setFormInputs(item?.data[0]);

        // Pre-select items based on updateSoStatus where orderConfirmed is true
        const confirmedMaterials = propsData?.updateSoStatus
          ?.filter((s) => s.orderConfirmed === true)
          ?.map((s) => s.materialCode) || [];

        // If all items are already confirmed, select all
        if (confirmedMaterials.length === 0) {
          setSelectedRows(updateItemData || []);
        } else {
          // Pre-select items that are confirmed
          const preSelectedItems = updateItemData?.filter((item) =>
            confirmedMaterials.includes(item.materialCode)
          ) || [];
          setSelectedRows(preSelectedItems);
        }
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    // Get warehouse data
    let obj1 = {
      codeType: "warehouse",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        const sortedData = (item.data || []).sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setGodownData(sortedData || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    // Get warehouse data
    let obj2 = {
      codeType: "truckCode",
    };
    await ItemService.getMasterData(obj2).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        const data = item.data || [];

        const sortedData = data
          .filter((x) => x.code !== "000")
          .sort((a, b) => Number(a.code) - Number(b.code));

        const others = data.find((x) => x.code === "000");

        if (others) sortedData.push(others);

        setTruckData(sortedData || []);
      } else {
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    // let obj3 = {
    //   queryName: "get_vehicleRegistrationNr",
    // };

    // await ItemService.generateCustomerQuery(obj3).then((item) => {
    //   console.log(">> item! title", item?.data);
    //   if (item?.status === 200 && Array.isArray(item?.data)) {
    //     const updatedData = [
    //       ...item.data,
    //       {
    //         codeType: "truckCode",
    //         code: "000",
    //         description: "OTHERS",
    //         name: "000 - OTHERS",
    //         id: "000",
    //       },
    //     ];
    //     setTruckData(updatedData);
    //   } else {
    //     setTruckData([]);
    //     console.log(">> Error: Loading Company Code");
    //   }
    // });

    // let obj3= {
    //  queryName: "get_vehicleRegistrationNr",
    // }
    // await ItemService.generateCustomerQuery(obj3).then((item) => {
    //   console.log(">> item! title", item?.data);
    //   if (item?.status === 200) {
    //     // setTruckData(item?.data);
    //   } else {
    //     // setTruckData([]);
    //     console.log(">> Error: Loading Company Code");
    //   }
    // });
  };

  useEffect(() => {
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsData]);

  // Get order status based on updateSoStatus
  const getOrderStatus = (materialCode) => {
    if (!propsData?.updateSoStatus) {
      return "Order Not Confirmed";
    }
    const status = propsData.updateSoStatus.find(
      (s) => s.materialCode === materialCode
    );
    if (status && status.orderConfirmed === true) {
      return "Order Confirmed";
    }
    return "Order Not Confirmed";
  };

  //get current time
  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5); // Format HH:mm (24-hour)
  };

  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Confirm Order - {propsData?.orderSchedulingNr || propsData?.documentNumber}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Line Items */}
        <div className="accordion  mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                  <i
                    className={`bi ${
                      isCardVisible1 ? "bi-chevron-right" : "bi-chevron-down"
                    }`}
                    onClick={toggleCardVisibility1}
                  ></i>
                </Col>
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PD</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Product </span>
                  <span className="subHeaderTitle">Product details</span>
                </Col>
              </Row>
            </h2>

            <div
              // id="acc"
              className={`accordion-collapse collapse show ${
                isCardVisible1 ? "visible" : ""
              }`}
            >
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <DataTable
                          title=""
                          columns={lineItemCol}
                          data={lineItmes}
                          pagination
                          paginationServer
                          selectableRows
                          selectableRowsHighlight
                          onSelectedRowsChange={handleRowSelect}
                          selectedRows={selectedRows}
                        />
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>

        {!viewStatus && (
          <Row className="my-4 d-flex justify-content-end">
            <Col
              // lg={{ span: 2, offset: 6 }}
              lg={2}
              className="d-flex justify-content-end"
            >
              <button
                className="btnTable btn-danger mt-2"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end">
              <button
                className="btnTable mt-2"
                onClick={handleMTO}
                disabled={disabled}
              >
                MTO
              </button>
            </Col>
            <Col lg={2} className="d-flex justify-content-end">
              <button
                className="btnTable mt-2"
                onClick={handleSave}
                disabled={disabled || isSaveDisabled}
              >
                Confirm
              </button>
            </Col>
          </Row>
        )}
      </Modal.Body>
    </Modal>
  );
});

export default OrderConfirmationModal;
